// ImageCarousel.js
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; 
// Import the carousel styles

import b1 from './images/b1.webp';import b2 from './images/b2.webp';import b3 from './images/b3.webp';import b4 from './images/b4.webp';import b6 from './images/b6.webp';import b7 from './images/b7.webp';import d1 from './images/d1.webp';import d2 from './images/d2.webp';import g1 from './images/g1.webp';import g2 from './images/g2.webp';import l1 from './images/l1.webp';import l2 from './images/l2.webp';import l3 from './images/l3.webp';



const ImageCarousel = () => {
  const images=[b1,b2,b3,b4,b6,b7,d1,d2,g1,g2,l1,l2,l3];
  return (
    <Carousel showArrows={true} showThumbs={true} showStatus={true}>
      {images.map((image, index) => (
        <div key={index}className='imgclasse'>
          <img src={image} alt={`Image_ ${index + 1}`} />
        </div>
      ))}
    </Carousel>
  );
};

export default ImageCarousel;
